import {
    CONFIGURE_TOPICS,
    SWITCH_TAB,
    FETCH_CHART_METRICS,
    FETCH_OCR_WORDCLOUD_DATA,
    RECOMMENDATION_DATA,
    RECOMMENDATION_DATA_LIST,
    CONFIG_RECOMMENDATION_FILTER_LIST,
    DATA_CLEANUP,
    TOGGLE_TAB_DIMENSION,
} from "../actions/insightsRecommendationActions";
import { formatInsightsChartData } from "../actions/insightsRecommendationActionsUtils";
import { isFulfilled, isPending, isRejected } from "./reducerUtils";

const initialState = {
    minimizeTab: true,
    currentPage: "help",
    queryLists: [],
    queryListLoading: false,
    ownBrand: null,
    ownBrandFilters: null,
    competitorsBrand: null,
    competitorsBrandFilters: null,
    chartData: {},
    chartDataGPT: {},
    chartDataLoadingGPT: false,
    chartDataLoading: {},
    chartLoadingFailed: {},
};

const insightsRecommendationReducer = (state = initialState, action) => {
    switch (action.type) {
        case isPending("INSIGHTS_QUERY_LIST"):
            return (state = {
                ...state,
                queryLists: [],
                queryListLoading: true,
            });
        case isRejected("INSIGHTS_QUERY_LIST"):
            return (state = {
                ...state,
                queryLists: [],
                queryListLoading: false,
            });
        case isFulfilled("INSIGHTS_QUERY_LIST"):
            return (state = {
                ...state,
                queryLists: action.payload.data.filters.topicsAndSubtopics,
                queryListLoading: false,
            });
        case CONFIGURE_TOPICS:
            return { ...state, ownBrand: action.payload.own_brand_topic ?? null, competitorsBrand: action.payload.competitor_brand_topic ?? null };

        case isFulfilled(CONFIG_RECOMMENDATION_FILTER_LIST):
            return {
                ...state,
                ownBrand: action.payload.data.recommendation_filter?.query_filter.filter.own?.topic_data ?? null,
                competitorsBrand: action.payload.data.recommendation_filter?.query_filter.filter.competitor?.topic_data ?? null,
                ownBrandFilters: action.payload.data.recommendation_filter?.query_filter.filter.own ?? null,
                competitorsBrandFilters: action.payload.data.recommendation_filter?.query_filter.filter.competitor ?? null,
            };

        case SWITCH_TAB: {
            return { ...state, currentPage: action.payload ?? "help" };
        }

        case TOGGLE_TAB_DIMENSION: {
            return { ...state, minimizeTab: action.payload ?? false };
        }

        case DATA_CLEANUP:
            return { ...state, chartData: {}, chartDataLoading: {}, chartDataGPT: {}, chartDataLoadingGPT: false };

        case isPending(FETCH_CHART_METRICS):
            return (state = {
                ...state,
            });

        case isRejected(FETCH_CHART_METRICS):
            return (state = {
                ...state,
            });
        case isFulfilled(FETCH_CHART_METRICS):
            return (state = {
                ...state,
                chartData: {
                    ...chartData,
                    [action.payload.chart_name]: action.payload.response,
                },
            });

        case isPending(FETCH_OCR_WORDCLOUD_DATA):
            return (state = {
                ...state,
                chartDataLoading: {
                    ...state.chartDataLoading,
                    [action.payload.chart_name]: {
                        ...state.chartDataLoading[action.payload.chart_name],
                        [action.payload.topic_name]: true,
                    },
                },
            });

        case isRejected(FETCH_OCR_WORDCLOUD_DATA):
            return (state = {
                ...state,
                chartDataLoading: {
                    ...state.chartDataLoading,
                    [action.payload.chart_name]: {
                        ...state.chartDataLoading[action.payload.chart_name],
                        [action.payload.topic_name]: false,
                    },
                },
            });
        case isFulfilled(FETCH_OCR_WORDCLOUD_DATA):
            return (state = {
                ...state,
                chartDataLoading: {
                    ...state.chartDataLoading,
                    [action.payload.chart_name]: {
                        ...state.chartDataLoading[action.payload.chart_name],
                        [action.payload.topic_name]: false,
                    },
                },
                chartData: {
                    ...state.chartData,
                    [action.payload.chart_name]: {
                        ...state.chartData[action.payload.chart_name],
                        [action.payload.topic_name]: formatInsightsChartData(action.payload),
                    },
                },
            });

        case isPending(RECOMMENDATION_DATA):
            return (state = {
                ...state,
                chartDataLoading: true,
            });

        case isRejected(RECOMMENDATION_DATA):
            return (state = {
                ...state,
            });
        case isFulfilled(RECOMMENDATION_DATA):
            return (state = {
                ...state,

                chartDataLoading: false,
                chartData: {
                    ...state.chartData,

                    [action.payload.chart_name]: {
                        [action.payload.topic_name]: action.payload.response.data.recommendations[0]
                            ? action.payload.response.data.recommendations[0]?.recommendation.response
                            : "",
                    },
                },
            });

        case isPending(RECOMMENDATION_DATA_LIST):
            return (state = {
                ...state,
                chartDataLoadingGPT: true,
            });

        case isRejected(RECOMMENDATION_DATA_LIST):
            return (state = {
                ...state,
            });
        case isFulfilled(RECOMMENDATION_DATA_LIST):
            return (state = {
                ...state,

                chartDataLoadingGPT: false,
                chartDataGPT: {
                    ...state.chartDataGPT,

                    [action.payload?.chart_name]: {
                        [action.payload?.topic_name]: action.payload?.response.data.recommendation
                            ? action.payload?.response.data.recommendation.recommendation_text
                            : "",
                    },
                },
            });

        default:
            return state;
    }
};
export default insightsRecommendationReducer;
